import { addProductWithResult } from "@iewcasia/Services/CartService";
import { setGA4Event } from "@iewcasia/Store/Handlers/Utilities/CustomTracking";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getWishListState } from "@insite/client-framework/Store/Data/WishLists/WishListsSelectors";
import { chain, SendDataToApi } from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";

replaceInChain(chain, SendDataToApi, async props => {
    const qtyOrdered = props.apiParameter.qtyOrdered;
    const result = await addProductWithResult(props.apiParameter);
    const pageType = getCurrentPage(props.getState()).type;

    if (result.successful) {
        props.apiResult = result.result;
        let additionalInfo = {};

        if (pageType === "ProductListPage") {
            const productList = document.querySelectorAll(".product-accordion-header");
            additionalInfo = {
                item_list_id: "product_list",
                item_list_name: "Product List",
                index:
                    Array.from(productList).findIndex(
                        product => product.getAttribute("data-part") === props.apiResult.erpNumber,
                    ) ||
                    Array.from(productList).findIndex(product =>
                        product.getAttribute("class")?.includes(props.apiResult.erpNumber),
                    ),
            };
        }

        if (pageType === "SearchPage") {
            const productList = document.querySelectorAll(".card_container__wrapper");
            additionalInfo = {
                item_list_id: "search_results",
                item_list_name: "Search Results",
                // set index where the product in the productList has props.apiResult.erpNumber contained in the class list
                index: Array.from(productList).findIndex(product =>
                    product.getAttribute("class")?.includes(props.apiResult.erpNumber),
                ),
            };
        }

        if (pageType === "MyListsDetailsPage") {
            const wishlistID = props.getState().pages.myListDetails.wishListId;

            if (!wishlistID) {
                return;
            }

            const wishlistData = await getWishListState(props.getState(), wishlistID).value;

            additionalInfo = {
                item_list_id: wishlistData?.id,
                item_list_name: wishlistData?.name,
                index: 1,
            };
        }
        // update the qtyordered in props.apiResult with the qtyOrdered from the apiParameter
        props.apiResult.qtyOrdered = qtyOrdered;

        setGA4Event([props.apiResult], "add_to_cart", additionalInfo);
    } else {
        if (result.statusCode === 403) {
            const { isAuthenticated, rememberMe } = props.getState().context.session;
            (isAuthenticated || rememberMe) && window.location.reload();
            return false;
        }

        props.parameter.onError?.(result.errorMessage);
        return false;
    }
});
